import { render, staticRenderFns } from "./DetailHoProduct.vue?vue&type=template&id=26fd23c8"
import script from "./DetailHoProduct.vue?vue&type=script&lang=js"
export * from "./DetailHoProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports